import { DEFAULT_LOCALE } from './locale.js';
import { domainCopy } from './i18n/index.js';
/** восемь сфер. порядок и состав фиксированы и не меняются (раздел 4 хендоффа). */
export const SPHERE_IDS = [
    'sostoyanie',
    'zdorovie',
    'otnosheniya',
    'prostranstvo',
    'dengi',
    'produkt',
    'vliyanie',
    'realizatsiya',
];
export const SPHERES = [
    { id: 'sostoyanie', nm: 'состояние', grp: 'in' },
    { id: 'zdorovie', nm: 'здоровье', grp: 'in' },
    { id: 'otnosheniya', nm: 'отношения', grp: 'in' },
    { id: 'prostranstvo', nm: 'пространство', grp: 'in' },
    { id: 'dengi', nm: 'деньги', grp: 'out' },
    { id: 'produkt', nm: 'продукт', grp: 'out' },
    { id: 'vliyanie', nm: 'влияние', grp: 'out' },
    { id: 'realizatsiya', nm: 'реализация', grp: 'out' },
];
/** максимум шкалы сферы */
export const TARGET = 10;
/** ватерлиния: две и более сферы ниже неё включают правило двух сфер */
export const THRESH = 6;
const SPHERE_ID_SET = new Set(SPHERE_IDS);
export function isSphereId(v) {
    return typeof v === 'string' && SPHERE_ID_SET.has(v);
}
export function sphereById(id) {
    const s = SPHERES.find((x) => x.id === id);
    if (!s)
        throw new Error(`unknown sphere: ${id}`);
    return s;
}
/** стандартное название сферы на языке человека */
export function sphereDefaultName(id, locale = DEFAULT_LOCALE) {
    return domainCopy(locale).spheres[id];
}
/** название сферы с учетом переименования; пустое или неизвестное — по умолчанию */
export function sphereLabel(id, names, locale = DEFAULT_LOCALE) {
    const own = names?.[id]?.trim();
    return own || sphereDefaultName(id, locale);
}
//# sourceMappingURL=spheres.js.map